import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'during_recruitment_process_do_materials_such_as_job'

export const dataPointDefinition = {
  retracedId: 'during_recruitment_process_do_materials_such_as_job',
  name: "During the recruitment process, do materials such as job description or job application forms reference an applicant's r",
  description:
    'Answer Yes if hiring materials (such as job descriptions or application forms) ever mention any of these elements in a manner that is not in line with applicable legal requirements. ',
  meta: {
    slcpMeta: {
      key: 'rh-dis-43',
      number: 'RH-DIS-1',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'rh-dis-43', version: '1.7.0', provider: 'slcp'}],
  sortingId: 34300,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
